<div *ngIf="isLoading" class="skeleton-wrapper">
  <!-- Skeleton Header -->
  <div class="skeleton-header">
    <div class="skeleton-box skeleton-breadcrumb"></div>
    <div class="skeleton-box skeleton-back"></div>
  </div>

  <!-- Skeleton Main Content -->
  <div class="skeleton-main">
    <div class="skeleton-content-grid">
      <!-- Left Sidebar -->
      <div class="skeleton-card">
        <div class="skeleton-box" style="height: 80px; width: 100%;"></div>
        <div class="skeleton-box" style="height: 40px; width: 60%; margin: 0 auto;"></div>
        <div class="skeleton-box" style="height: 140px; width: 100%;"></div>
        <div class="skeleton-box" style="height: 44px; width: 100%;"></div>
        <div class="skeleton-box" style="height: 160px; width: 100%;"></div>
      </div>

      <!-- Right Area -->
      <div style="display: flex; flex-direction: column; gap: 12px;">
        <!-- Action Buttons -->
        <div style="display: flex; justify-content: flex-end; gap: 8px;">
          <div class="skeleton-box" style="height: 38px; width: 100px;"></div>
          <div class="skeleton-box" style="height: 38px; width: 100px;"></div>
          <div class="skeleton-box" style="height: 38px; width: 180px;"></div>
        </div>

        <!-- Status Timeline -->
        <div class="skeleton-card">
          <div class="skeleton-box" style="height: 24px; width: 200px;"></div>
          <div style="display: flex; justify-content: space-between; padding: 20px 0;">
            <div class="skeleton-circle" style="width: 48px; height: 48px;"></div>
            <div class="skeleton-circle" style="width: 48px; height: 48px;"></div>
            <div class="skeleton-circle" style="width: 48px; height: 48px;"></div>
            <div class="skeleton-circle" style="width: 48px; height: 48px;"></div>
            <div class="skeleton-circle" style="width: 48px; height: 48px;"></div>
          </div>
        </div>

        <!-- Order Information -->
        <div class="skeleton-card">
          <div class="skeleton-box" style="height: 24px; width: 150px;"></div>
          <div style="display: grid; grid-template-columns: repeat(3, 1fr); gap: 12px;">
            <div class="skeleton-box" style="height: 60px;"></div>
            <div class="skeleton-box" style="height: 60px; grid-column: span 2;"></div>
            <div class="skeleton-box" style="height: 60px;"></div>
            <div class="skeleton-box" style="height: 60px;"></div>
            <div class="skeleton-box" style="height: 60px;"></div>
          </div>
        </div>

        <!-- Assigned To -->
        <div class="skeleton-card">
          <div class="skeleton-box" style="height: 24px; width: 120px;"></div>
          <div style="display: flex; align-items: center; gap: 12px;">
            <div class="skeleton-circle" style="width: 40px; height: 40px;"></div>
            <div class="skeleton-box" style="height: 40px; flex: 1;"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div *ngIf="!isLoading" class="page-container fade-in-up">

  <!-- Header -->
  <div class="page-header">
    <div class="header-content">
      <a href="javascript:void(0)" class="go-back-link" (click)="goBack()">
        <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
        </svg>
        Go Back
      </a>
    </div>
  </div>

  <!-- Main Content -->
  <div class="main-content">
    <div class="content-wrapper">

      <!-- LEFT SIDEBAR - ORDER CARD -->
      <div class="order-card">
        <div class="order-icon-wrapper">
          <!-- <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
            <path
              d="M3.375 3C2.339 3 1.5 3.84 1.5 4.875v.75c0 1.036.84 1.875 1.875 1.875h17.25c1.035 0 1.875-.84 1.875-1.875v-.75C22.5 3.839 21.66 3 20.625 3H3.375z" />
            <path fill-rule="evenodd"
              d="M3.087 9l.54 9.176A3 3 0 006.62 21h10.757a3 3 0 002.995-2.824L20.913 9H3.087zm6.133 2.845a.75.75 0 011.06 0l1.72 1.72 1.72-1.72a.75.75 0 111.06 1.06l-1.72 1.72 1.72 1.72a.75.75 0 11-1.06 1.06L12 15.685l-1.72 1.72a.75.75 0 11-1.06-1.06l1.72-1.72-1.72-1.72a.75.75 0 010-1.06z"
              clip-rule="evenodd" />
          </svg> -->
          <div *ngIf="orderData" class="order-icon"
            [class.pickup]="orderData?.order_type === 'pickup' && orderData?.current_driver?.id"
            [class.delivery]="orderData.order_type === 'delivery' && orderData?.current_driver?.id"
            [class.warehouse]="orderData.order_type === 'warehouse' && orderData?.current_driver?.id">


            <!-- ===== DELIVERY ICONS ===== -->
            <ng-container *ngIf="orderData.order_type === 'delivery'">

              <!-- Assigned Delivery -->
              <div *ngIf="orderData?.current_driver?.id">D</div>

              <!-- Unassigned Delivery -->
              <svg *ngIf="!orderData?.current_driver?.id" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
                fill="none" style="width: 48px; height: 48px;">
                <rect x="2" y="2" width="20" height="20" rx="4" stroke="#008A51" stroke-width="1" fill="none" />
                <text x="12" y="17" text-anchor="middle" font-size="13" font-weight="100" fill="#008A51"
                  font-family="Arial, sans-serif">D</text>
              </svg>

            </ng-container>


            <!-- ===== PICKUP ICONS ===== -->
            <ng-container *ngIf="orderData.order_type === 'pickup'">

              <!-- Assigned Pickup -->
              <div *ngIf="orderData?.current_driver?.id">P</div>

              <!-- Unassigned Pickup -->
              <svg *ngIf="!orderData?.current_driver?.id" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
                fill="none" style="width: 48px; height: 48px;">
                <rect x="2" y="2" width="20" height="20" rx="4" stroke="#DB2777" stroke-width="1" fill="none" />
                <text x="12" y="17" text-anchor="middle" font-size="13" font-weight="100" fill="#DB2777"
                  font-family="Arial, sans-serif">P</text>
              </svg>

            </ng-container>


            <!-- ===== WAREHOUSE ===== -->
            <ng-container *ngIf="orderData.order_type === 'warehouse'">
              <!-- Assigned Warehouse -->
              <div *ngIf="orderData?.current_driver?.id">W</div>

              <!-- Unassigned Warehouse -->
              <svg *ngIf="!orderData?.current_driver?.id" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
                fill="none" style="width: 48px; height: 48px;">
                <rect x="2" y="2" width="20" height="20" rx="4" stroke="#1e40af" stroke-width="1" fill="none" />
                <text x="12" y="17" text-anchor="middle" font-size="13" font-weight="100" fill="#1e40af"
                  font-family="Arial, sans-serif">W</text>
              </svg>

            </ng-container>
            <!-- <span *ngIf="orderData.order_type === 'warehouse'">W</span> -->

          </div>

        </div>
        <div class="order-number">
          <div *ngIf="orderData?.order_type == 'pickup'  && orderData?.parent_order == null"
            class="DeliveryNumber fontSize10">
            <h4>{{ orderData?.po }}</h4>
            Committed Time : {{ getFormattedTime1() ||'N/A' }} |
            {{ convertToLocalDate(orderData?.pickup_date) }}
          </div>
          <div *ngIf="orderData?.order_type == 'pickup' && orderData?.parent_order != null"
            class="DeliveryNumber fontSize10">
            <h4>{{ orderData?.order_no }}</h4>
            Committed Time : {{ getFormattedTime1() ||'N/A' }} |
            {{ convertToLocalDate(orderData?.pickup_date) }}
          </div>
          <div *ngIf="orderData?.order_type == 'delivery'" class="DeliveryNumber fontSize10">
            <h4>{{ orderData?.order_no || 'N/A'}}</h4>
            Committed Time : {{ getFormattedTime() ||'N/A' }} |
            {{convertToLocalDate(orderData?.dely_date) }}
          </div>
        </div>

        <!-- Map -->
        <div class="order-map" *ngIf="mapEmbedUrl">
          <iframe [src]="mapEmbedUrl" loading="lazy">
          </iframe>
          <div class="map-overlay">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
              <path fill-rule="evenodd"
                d="M11.54 22.351l.07.04.028.016a.76.76 0 00.723 0l.028-.015.071-.041a16.975 16.975 0 001.144-.742 19.58 19.58 0 002.683-2.282c1.944-1.99 3.963-4.98 3.963-8.827a8.25 8.25 0 00-16.5 0c0 3.846 2.02 6.837 3.963 8.827a19.58 19.58 0 002.682 2.282 16.975 16.975 0 001.145.742zM12 13.5a3 3 0 100-6 3 3 0 000 6z"
                clip-rule="evenodd" />
            </svg>
            {{ orderData?.order_type === 'pickup' ? 'Pickup Location' : (orderData?.order_type === 'warehouse' ?
            'Warehouse Location' : 'Delivery Location') }}
          </div>
        </div>
        <p class="track-note">Real-time order tracking active</p>
        <!--  -->
        <button class="track-button" [ngClass]="{
            'disabled-custom': (orderData?.order_status !== 'en-route' && orderData?.order_status !== 'arrived'),
            'status-enroute': orderData?.order_status === 'en-route'
          }" (click)="trackOrder()">
          <span class="track-icon">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2.5"
              stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" d="M15 10.5a3 3 0 11-6 0 3 3 0 016 0z" />
              <path stroke-linecap="round" stroke-linejoin="round"
                d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1115 0z" />
            </svg>
          </span>
          Track Order
        </button>

        <!-- Upload Packing Slip -->
        <div class="upload-section">
          <label class="upload-label">Packing Slip</label>
          <div class="upload-placeholder" [class.has-image]="uploadedImageUrl" (click)="uploadPackingSlip()">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
              stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round"
                d="M2.25 15.75l5.159-5.159a2.25 2.25 0 013.182 0l5.159 5.159m-1.5-1.5l1.409-1.409a2.25 2.25 0 013.182 0l2.909 2.909m-18 3.75h16.5a1.5 1.5 0 001.5-1.5V6a1.5 1.5 0 00-1.5-1.5H3.75A1.5 1.5 0 002.25 6v12a1.5 1.5 0 001.5 1.5zm10.5-11.25h.008v.008h-.008V8.25zm.375 0a.375.375 0 11-.75 0 .375.375 0 01.75 0z" />
            </svg>
            <p *ngIf="!uploadedImageUrl">Click to upload image</p>

            <!-- Image Preview -->
            <img [src]="uploadedImageUrl" alt="Preview" class="upload-preview"
              *ngIf="uploadedImageUrl && !uploadedImageUrl.toLowerCase().endsWith('.pdf') && !uploadedImageUrl.startsWith('data:application/pdf')">

            <!-- PDF Placeholder -->
            <div class="pdf-placeholder"
              *ngIf="uploadedImageUrl && (uploadedImageUrl.toLowerCase().endsWith('.pdf') || uploadedImageUrl.startsWith('data:application/pdf'))">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round"
                  d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m2.25 0H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z" />
              </svg>
              <span>PDF Document</span>
            </div>

            <button class="upload-clear-btn" *ngIf="uploadedImageUrl" (click)="clearUpload(); $event.stopPropagation()">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
                stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
          <input type="file" id="fileInput" style="display: none;" accept=".pdf,.jpg,.jpeg,.png"
            (change)="handleFileUpload($event)">
          <button class="upload-button" [class.uploaded]="uploadedImageUrl" (click)="uploadPackingSlip()"
            [disabled]="isUploading">
            <svg *ngIf="!isUploading" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
              stroke-width="2" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round"
                d="M3 16.5v2.25A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75V16.5m-13.5-9L12 3m0 0l4.5 4.5M12 3v13.5" />
            </svg>
            <div *ngIf="isUploading" class="spinner"></div>
            <span *ngIf="!isUploading">
              <ng-container *ngIf="selectedFile; else noSelection">
                {{ uploadedImageUrlId ? 'Confirm Change' : 'Confirm Upload' }}
              </ng-container>
              <ng-template #noSelection>
                {{ uploadedImageUrlId ? 'Change Packing Slip' : 'Upload Packing Slip' }}
              </ng-template>
            </span>
            <span *ngIf="isUploading">Uploading...</span>
          </button>
        </div>

        <!-- Driver Uploaded Photo -->
        <div class="upload-section" style="margin-top: 20px;" *ngIf="orderData?.receiver_details?.[0]?.photo">
          <label class="upload-label">Driver Uploaded Photo</label>
          <div class="upload-placeholder has-image" (click)="openSignatureModal(orderData?.receiver_details?.[0]?.photo)" title="View Photo">
            <img [src]="orderData?.receiver_details?.[0]?.photo" alt="Driver Photo Preview" class="upload-preview">
          </div>
        </div>
      </div>

      <!-- RIGHT CONTENT AREA -->
      <div class="details-content">

        <!-- ACTION BUTTONS -->
        <div class="action-section">
          <div class="action-buttons">
            <button
              *ngIf="orderData  && orderData?.order_status != 'successful' && orderData?.order_status != 'unsuccessful' && orderData?.order_status != 'cancelled' && orderData?.order_status != 'en-route'  && orderData?.order_status != 'arrived' && orderData?.order_status != 'warehouse'"
              class="action-btn btn-edit" (click)="editOrder(orderData)">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
                stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round"
                  d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l8.932-8.931zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0115.75 21H5.25A2.25 2.25 0 013 18.75V8.25A2.25 2.25 0 015.25 6H10" />
              </svg>
              Edit
            </button>
            <button class="action-btn btn-delete" (click)="deleteOrder()">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
                stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round"
                  d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0" />
              </svg>
              Delete
            </button>
            <button class="action-btn btn-notifications" (click)="openNotifications()">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                <path
                  d="M5.85 3.5a.75.75 0 00-1.117-1 9.719 9.719 0 00-2.348 4.876.75.75 0 001.479.248A8.219 8.219 0 015.85 3.5zM19.267 2.5a.75.75 0 10-1.118 1 8.22 8.22 0 011.987 4.124.75.75 0 001.48-.248A9.72 9.72 0 0019.266 2.5z" />
                <path fill-rule="evenodd"
                  d="M12 2.25A6.75 6.75 0 005.25 9v.75a8.217 8.217 0 01-2.119 5.52.75.75 0 00.298 1.206c1.544.57 3.16.99 4.831 1.243a3.75 3.75 0 107.48 0 24.583 24.583 0 004.83-1.244.75.75 0 00.298-1.205 8.217 8.217 0 01-2.118-5.52V9A6.75 6.75 0 0012 2.25zM9.75 18c0-.034 0-.067.002-.1a25.05 25.05 0 004.496 0l.002.1a2.25 2.25 0 11-4.5 0z"
                  clip-rule="evenodd" />
              </svg>
              Recent Notifications
            </button>
          </div>
        </div>

        <!-- STATUS PROGRESS -->
        <div class="status-section">
          <h3 class="status-header">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
              stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" d="M12 6v6h4.5m4.5 0a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            Order Status Timeline
          </h3>

          <div class="status-progress">
            <div class="status-line">
              <div class="status-line-progress"></div>
              <div class="status-truck" [style.left.%]="truckPosition">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                  <path
                    d="M3.375 4.5C2.339 4.5 1.5 5.34 1.5 6.375V13.5h12V6.375c0-1.036-.84-1.875-1.875-1.875h-8.25zM13.5 15h-12v2.625c0 1.035.84 1.875 1.875 1.875h.375a3 3 0 116 0h3a.75.75 0 00.75-.75V15z" />
                  <path
                    d="M8.25 19.5a1.5 1.5 0 10-3 0 1.5 1.5 0 003 0zM15.75 6.75a.75.75 0 00-.75.75v11.25c0 .087.015.17.042.248a3 3 0 015.958.464c.853-.175 1.522-.935 1.464-1.883a18.659 18.659 0 00-3.732-10.104 1.837 1.837 0 00-1.47-.725H15.75z" />
                  <path d="M19.5 19.5a1.5 1.5 0 10-3 0 1.5 1.5 0 003 0z" />
                </svg>
              </div>
            </div>

            <div class="status-step" *ngFor="let step of statusSteps" [class.completed]="step.completed"
              [class.active]="step.active" [class.current]="step.isCurrent"
              [class.unsuccessful]="step.key === 'unsuccessful'" [class.cancelled]="step.key === 'cancelled'">
              <div class="status-icon-wrapper">
                <ng-container [ngSwitch]="step.icon">
                  <svg *ngSwitchCase="'clipboard-check'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
                    fill="currentColor">
                    <path fill-rule="evenodd"
                      d="M7.502 6h7.128A3.375 3.375 0 0118 9.375v9.375a3 3 0 003-3V6.108c0-1.505-1.125-2.811-2.664-2.94a48.972 48.972 0 00-.673-.05A3 3 0 0015 1.5h-1.5a3 3 0 00-2.663 1.618c-.225.015-.45.032-.673.05C8.662 3.295 7.554 4.542 7.502 6zM13.5 3A1.5 1.5 0 0012 4.5h4.5A1.5 1.5 0 0015 3h-1.5z"
                      clip-rule="evenodd" />
                    <path fill-rule="evenodd"
                      d="M3 9.375C3 8.339 3.84 7.5 4.875 7.5h9.75c1.036 0 1.875.84 1.875 1.875v11.25c0 1.035-.84 1.875-1.875 1.875h-9.75A1.875 1.875 0 013 20.625V9.375zm9.586 4.594a.75.75 0 00-1.172-.938l-2.476 3.096-.908-.907a.75.75 0 00-1.06 1.06l1.5 1.5a.75.75 0 001.116-.062l3-3.75z"
                      clip-rule="evenodd" />
                  </svg>

                  <svg *ngSwitchCase="'cube'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
                    fill="currentColor">
                    <path
                      d="M3.375 3C2.339 3 1.5 3.84 1.5 4.875v.75c0 1.036.84 1.875 1.875 1.875h17.25c1.035 0 1.875-.84 1.875-1.875v-.75C22.5 3.839 21.66 3 20.625 3H3.375z" />
                    <path fill-rule="evenodd"
                      d="M3.087 9l.54 9.176A3 3 0 006.62 21h10.757a3 3 0 002.995-2.824L20.913 9H3.087zM12 10.5a.75.75 0 01.75.75v4.94l1.72-1.72a.75.75 0 111.06 1.06l-3 3a.75.75 0 01-1.06 0l-3-3a.75.75 0 111.06-1.06l1.72 1.72v-4.94a.75.75 0 01.75-.75z"
                      clip-rule="evenodd" />
                  </svg>

                  <svg *ngSwitchCase="'truck'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
                    fill="currentColor">
                    <path
                      d="M3.375 4.5C2.339 4.5 1.5 5.34 1.5 6.375V13.5h12V6.375c0-1.036-.84-1.875-1.875-1.875h-8.25zM13.5 15h-12v2.625c0 1.035.84 1.875 1.875 1.875h.375a3 3 0 116 0h3a.75.75 0 00.75-.75V15z" />
                    <path
                      d="M8.25 19.5a1.5 1.5 0 10-3 0 1.5 1.5 0 003 0zM15.75 6.75a.75.75 0 00-.75.75v11.25c0 .087.015.17.042.248a3 3 0 015.958.464c.853-.175 1.522-.935 1.464-1.883a18.659 18.659 0 00-3.732-10.104 1.837 1.837 0 00-1.47-.725H15.75z" />
                    <path d="M19.5 19.5a1.5 1.5 0 10-3 0 1.5 1.5 0 003 0z" />
                  </svg>

                  <svg *ngSwitchCase="'map-pin'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
                    fill="currentColor">
                    <path fill-rule="evenodd"
                      d="m11.54 22.351.07.04.028.016a.76.76 0 0 0 .723 0l.028-.015.071-.041a16.975 16.975 0 0 0 1.144-.742 19.58 19.58 0 0 0 2.683-2.282c1.944-1.99 3.963-4.98 3.963-8.827a8.25 8.25 0 0 0-16.5 0c0 3.846 2.02 6.837 3.963 8.827a19.58 19.58 0 0 0 2.682 2.282 16.975 16.975 0 0 0 1.145.742ZM12 13.5a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"
                      clip-rule="evenodd" />
                  </svg>

                  <svg *ngSwitchCase="'check-circle'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
                    fill="currentColor">
                    <path fill-rule="evenodd"
                      d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12zm13.36-1.814a.75.75 0 10-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 00-1.06 1.06l2.25 2.25a.75.75 0 001.14-.094l3.75-5.25z"
                      clip-rule="evenodd" />
                  </svg>
                </ng-container>
              </div>
              <div class="status-label">{{ step.label }}</div>
              <div class="status-time" *ngIf="step.time">{{ step.time }}</div>
            </div>
          </div>
        </div>

        <!-- ORDER INFORMATION -->
        <div class="info-section">
          <div class="info-section-header">
            <h3 class="info-section-title">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round"
                  d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z" />
              </svg>
              Order Details
            </h3>
            <span class="status-badge" [ngClass]="getStatusBadgeClass()">
              {{ getStatusBadgeText() }}
              <span *ngIf="(orderData?.order_type === 'delivery' && orderData?.is_dely_first_delivery) 
        || (orderData?.order_type === 'pickup' && orderData?.is_pickup_first_delivery)" class="first-delivery">
                {{ orderData?.order_type === 'delivery' ? orderData?.is_dely_first_delivery :
                orderData?.is_pickup_first_delivery }}
              </span>
            </span>
          </div>

          <div class="info-cards-grid">

            <!-- ROW 1: Order ID (1 col) + Company Info (2 col) -->
            <div class="info-card highlight" style="grid-column: span 1;">
              <div class="info-card-label">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                  <path fill-rule="evenodd"
                    d="M4.5 2A1.5 1.5 0 003 3.5v13A1.5 1.5 0 004.5 18h11a1.5 1.5 0 001.5-1.5V7.621a1.5 1.5 0 00-.44-1.06l-4.12-4.122A1.5 1.5 0 0011.378 2H4.5zm2.25 8.5a.75.75 0 000 1.5h6.5a.75.75 0 000-1.5h-6.5zm0 3a.75.75 0 000 1.5h6.5a.75.75 0 000-1.5h-6.5z"
                    clip-rule="evenodd" />
                </svg>
                Order (Services ID)
              </div>
              <div class="info-card-value">
                <div *ngIf="orderData?.order_type == 'pickup' && orderData?.parent_order == null">
                  {{ orderData?.po }} {{ getMultipleOrderIds(orderData) }}
                </div>
                <div *ngIf="orderData?.order_type == 'pickup' && orderData?.parent_order != null">
                  {{ orderData?.order_no }} {{ getMultipleOrderIds(orderData) }}
                </div>
                <div *ngIf="orderData?.order_type == 'delivery'">
                  {{ orderData?.order_no }} {{ getMultipleOrderIds(orderData) }}
                </div>
              </div>
            </div>

            <div class="info-card" style="grid-column: span 2;">
              <div class="info-card-label">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                  <path
                    d="M10 8a3 3 0 100-6 3 3 0 000 6zM3.465 14.493a1.23 1.23 0 00.41 1.412A9.957 9.957 0 0010 18c2.31 0 4.438-.784 6.131-2.1.43-.333.604-.903.408-1.41a7.002 7.002 0 00-13.074.003z" />
                </svg>
                Company info
              </div>
              <div class="info-card-value company-name"
                style="display: flex; align-items: flex-start; gap: 8px; margin-left: 12px; flex-wrap: nowrap;">
                <svg xmlns="http://www.w3.org/2000/svg"
                  style="width: 16px; height: 16px; color: #9ca3af; flex-shrink: 0; margin-top: 2px;"
                  viewBox="0 0 20 20" fill="currentColor">
                  <path fill-rule="evenodd"
                    d="M4 4a2 2 0 012-2h8a2 2 0 012 2v12a1 1 0 110 2h-3a1 1 0 01-1-1v-2a1 1 0 00-1-1H9a1 1 0 00-1 1v2a1 1 0 01-1 1H4a1 1 0 110-2V4zm3 1h2v2H7V5zm2 4H7v2h2V9zm2-4h2v2h-2V5zm2 4h-2v2h2V9z"
                    clip-rule="evenodd" />
                </svg>
                <div style="flex: 1; word-break: break-word;">
                  <span class="company-text">{{ orderData?.parent_order == null ? (orderData?.order_type === 'delivery'
                    ? orderData?.dely_company_name : orderData?.pickup_company_name) : orderData?.dely_company_name
                    }}</span>
                  <span class="contact-name"> ({{ orderData?.customer_name }})</span>
                </div>
              </div>

              <div class="info-card-value address-details"
                style="display: flex; align-items: flex-start; gap: 8px; margin-top: 6px; margin-left: 12px; flex-wrap: nowrap;">
                <svg xmlns="http://www.w3.org/2000/svg"
                  style="width: 16px; height: 16px; color: #9ca3af; flex-shrink: 0; margin-top: 2px;"
                  viewBox="0 0 20 20" fill="currentColor">
                  <path fill-rule="evenodd"
                    d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z"
                    clip-rule="evenodd" />
                </svg>
                <div style="flex: 1; word-break: break-word;">
                  {{ orderData?.parent_order == null ? (orderData?.order_type === 'delivery' ?
                  orderData?.dely_address?.address : orderData?.pickup_address?.address) :
                  orderData?.dely_address?.address }}
                </div>
              </div>
            </div>

            <!-- ROW 2: Received By + Signature + Special Instructions -->
            <div class="info-card">
              <div class="info-card-label">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                  <path fill-rule="evenodd"
                    d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-5.5-2.5a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0zM10 12a5.99 5.99 0 00-4.793 2.39A6.483 6.483 0 0010 16.5a6.483 6.483 0 004.793-2.11A5.99 5.99 0 0010 12z"
                    clip-rule="evenodd" />
                </svg>
                Received by
              </div>
              <div class="info-card-value">
                <span [ngClass]="{'not-available': !orderData?.receiver_details?.[0]?.receiver_name}">
                  {{ orderData?.receiver_details?.[0]?.receiver_name || 'N/A' }}
                </span>
              </div>
            </div>

            <div class="info-card">
              <div class="info-card-label">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                  <path fill-rule="evenodd"
                    d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a.75.75 0 000 1.5h.253a.25.25 0 01.244.304l-.459 2.066A1.75 1.75 0 0010.747 15H11a.75.75 0 000-1.5h-.253a.25.25 0 01-.244-.304l.459-2.066A1.75 1.75 0 009.253 9H9z"
                    clip-rule="evenodd" />
                </svg>
                Signature
              </div>
              <div class="info-card-value">
                <img *ngIf="orderData?.receiver_details?.[0]?.signature" class="signature-image signature"
                  src="{{orderData?.receiver_details[0]?.signature}}"
                  (click)="openSignatureModal(orderData?.receiver_details[0]?.signature)" title="View signature" />
                <span *ngIf="!orderData?.receiver_details?.[0]?.signature" class="not-available">N/A</span>
              </div>
            </div>

            <div class="info-card">
              <div class="info-card-label">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                  <path fill-rule="evenodd"
                    d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a.75.75 0 000 1.5h.253a.25.25 0 01.244.304l-.459 2.066A1.75 1.75 0 0010.747 15H11a.75.75 0 000-1.5h-.253a.25.25 0 01-.244-.304l.459-2.066A1.75 1.75 0 009.253 9H9z"
                    clip-rule="evenodd" />
                </svg>
                Remarks / Special Instructions
              </div>
              <div class="info-card-value">
                <span
                  [ngClass]="{'not-available': !(orderData?.order_type === 'delivery' ? orderData?.dely_note : orderData?.pickup_note)}">
                  {{ (orderData?.order_type === 'delivery' ? orderData?.dely_note : orderData?.pickup_note) || 'N/A' }}
                </span>
              </div>
            </div>

            <!-- ROW 3: Committed Time + Time Interval + Requested By -->
            <div class="info-card">
              <div class="info-card-label">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                  <path fill-rule="evenodd"
                    d="M10 18a8 8 0 100-16 8 8 0 000 16zm-.75-13a.75.75 0 011.5 0v4.25l2.97 1.485a.75.75 0 01-.67 1.342l-3.5-1.75a.75.75 0 01-.4-.664V5z"
                    clip-rule="evenodd" />
                </svg>
                Committed Time
              </div>
              <div class="info-card-value">
                <span *ngIf="orderData?.order_type == 'delivery'" [ngClass]="{'not-available': !getFormattedTime()}">{{
                  getFormattedTime() || 'N/A' }}</span>
                <span *ngIf="orderData?.order_type == 'pickup'" [ngClass]="{'not-available': !getFormattedTime1()}">{{
                  getFormattedTime1() || 'N/A' }}</span>
              </div>
            </div>

            <div class="info-card">
              <div class="info-card-label">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                  <path fill-rule="evenodd"
                    d="M4.25 2A2.25 2.25 0 002 4.25v11.5A2.25 2.25 0 004.25 18h11.5A2.25 2.25 0 0018 15.75V4.25A2.25 2.25 0 0015.75 2H4.25zM15 5.75a.75.75 0 00-1.5 0v8.5a.75.75 0 001.5 0v-8.5zm-8.5 6a.75.75 0 00-1.5 0v2.5a.75.75 0 001.5 0v-2.5zm3.5-4a.75.75 0 00-1.5 0v6.5a.75.75 0 001.5 0v-6.5z"
                    clip-rule="evenodd" />
                </svg>
                Time Interval
              </div>
              <div class="info-card-value">
                <span
                  [ngClass]="{'not-available': !(orderData?.order_type === 'delivery' ? orderData?.dely_time_interval : orderData?.pickup_time_interval)}">
                  {{ (orderData?.order_type === 'delivery' ? orderData?.dely_time_interval :
                  orderData?.pickup_time_interval) || 'N/A' }}
                </span>
              </div>
            </div>

            <div class="info-card">
              <div class="info-card-label"
                style="display: flex; justify-content: space-between; align-items: flex-start; width: 100%;">
                <span style="display: flex; flex-direction: column; align-items: flex-start;">
                  <span style="display: flex; align-items: center; gap: 6px;">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                      <path
                        d="M10 8a3 3 0 100-6 3 3 0 000 6zM3.465 14.493a1.23 1.23 0 00.41 1.412A9.957 9.957 0 0010 18c2.31 0 4.438-.784 6.131-2.1.43-.333.604-.903.408-1.41a7.002 7.002 0 00-13.074.003z" />
                    </svg>
                    Entered By
                  </span>
                  <span *ngIf="getAddedByName()"
                    style="font-size: 14px; color: var(--text-muted); margin-top: 4px; text-transform: none; font-weight: normal; margin-left: 20px;">
                    (Added by)
                  </span>
                </span>
                <button *ngIf="hasEditLogs()" class="history-btn" (click)="openHistoryModal()">Show History</button>
              </div>
              <div class="info-card-value" style="display: block; width: 100%;">
                <div>{{ orderData?.created_by?.first_name }} {{ orderData?.created_by?.last_name }}</div>
                <div *ngIf="getAddedByName()"
                  style="font-size: 14px; font-weight: normal; margin-top: 4px; color: var(--text-muted);">
                  ({{ getAddedByName() }})
                </div>
              </div>
            </div>

            <!-- ROW 4: Order Date + Order Time + Delivery/Pickup Date -->
            <!-- <div class="info-card">
      <div class="info-card-label">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
          <path fill-rule="evenodd"
            d="M5.75 2a.75.75 0 01.75.75V4h7V2.75a.75.75 0 011.5 0V4h.25A2.75 2.75 0 0118 6.75v8.5A2.75 2.75 0 0115.25 18H4.75A2.75 2.75 0 012 15.25v-8.5A2.75 2.75 0 014.75 4H5V2.75A.75.75 0 015.75 2zm-1 5.5c-.69 0-1.25.56-1.25 1.25v6.5c0 .69.56 1.25 1.25 1.25h10.5c.69 0 1.25-.56 1.25-1.25v-6.5c0-.69-.56-1.25-1.25-1.25H4.75z"
            clip-rule="evenodd" />
        </svg>
        Order Date
      </div>
      <div class="info-card-value">{{ convertToLocalDate(orderData?.created_at) }}</div>
    </div>

    <div class="info-card">
      <div class="info-card-label">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
          <path fill-rule="evenodd"
            d="M10 18a8 8 0 100-16 8 8 0 000 16zm.75-13a.75.75 0 00-1.5 0v5c0 .414.336.75.75.75h4a.75.75 0 000-1.5h-3.25V5z"
            clip-rule="evenodd" />
        </svg>
        Order Time
      </div>
      <div class="info-card-value">{{ orderData?.created_at | date : "shortTime" }}</div>
    </div>

    <div *ngIf="orderData?.order_type == 'delivery'" class="info-card">
      <div class="info-card-label">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
          <path
            d="M6.3 2.841A1.5 1.5 0 004 4.11V15.89a1.5 1.5 0 002.3 1.269l9.344-5.89a1.5 1.5 0 000-2.538L6.3 2.84z" />
        </svg>
        Delivery Date
      </div>
      <div class="info-card-value">{{ convertToLocalDate(orderData?.dely_date) }}</div>
    </div>

    <div *ngIf="orderData?.order_type == 'pickup'" class="info-card">
      <div class="info-card-label">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
          <path
            d="M6.3 2.841A1.5 1.5 0 004 4.11V15.89a1.5 1.5 0 002.3 1.269l9.344-5.89a1.5 1.5 0 000-2.538L6.3 2.84z" />
        </svg>
        Pickup Date
      </div>
      <div class="info-card-value">{{ convertToLocalDate(orderData?.pickup_date) }}</div>
    </div> -->

          </div>
        </div>
        <div
          *ngIf="orderData?.order_status == 'unsuccessful' || orderData?.order_status == 'successful' || orderData?.order_status == 'cancelled'"
          class="status-feedback-card">

          <div class="feedback-top">
            <h3 class="section-title">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
                stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round"
                  d="M11.35 3.836c.002.392.24.745.597.906a3.75 3.75 0 0 0 1.547.332c.1.002.2.001.3-.002a2.25 2.25 0 0 1 2.304 2.25v2.25m3 3h3a2.25 2.25 0 0 1 2.25 2.25v6.75A2.25 2.25 0 0 1 21 21H3a2.25 2.25 0 0 1-2.25-2.25V6.75A2.25 2.25 0 0 1 3 4.5h3a2.25 2.25 0 0 1 2.25 2.25v2.25" />
              </svg>
              Order is:
              <span class="status-badge" [ngClass]="orderData?.order_status?.toLowerCase()">
                {{ orderData?.order_status | uppercase }}
                <span *ngIf="(orderData?.order_type === 'delivery' && orderData?.is_dely_first_delivery) 
                  || (orderData?.order_type === 'pickup' && orderData?.is_pickup_first_delivery)"
                  class="first-delivery">
                  {{ orderData?.order_type === 'delivery' ? orderData?.is_dely_first_delivery :
                  orderData?.is_pickup_first_delivery }}
                </span>
              </span>
            </h3>
          </div>

          <div class="feedback-columns">
            <div class="feedback-group">
              <div class="group-header">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
                  stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round"
                    d="M15 9h3.75M15 12h3.75M15 15h3.75M4.5 19.5h15a2.25 2.25 0 0 0 2.25-2.25V6.75A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25v10.5A2.25 2.25 0 0 0 4.5 19.5" />
                </svg>
                Driver Reasons
              </div>
              <ul class="reasons-list-clean" *ngIf="unsuccessfullReasons?.length > 0; else noDrReas">
                <li *ngFor="let reason of unsuccessfullReasons" [ngClass]="reason.status?.toLowerCase()">
                  <div class="reason-content-wrapper">
                    <span class="reason-text" [ngClass]="reason.status?.toLowerCase()">{{ reason?.reason?.reason_text
                      }}</span>
                    <p class="other-reason" *ngIf="reason?.other_reason">{{ reason.other_reason }}</p>
                  </div>
                </li>
              </ul>
              <ng-template #noDrReas><span class="no-feedback">No reasons recorded</span></ng-template>
            </div>

            <div class="feedback-group">
              <div class="group-header">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
                  stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round"
                    d="M17.982 18.725A7.488 7.488 0 0 0 12 15.75a7.488 7.488 0 0 0-5.982 2.975m11.963 0a9 9 0 1 0-11.963 0m11.963 0A8.966 8.966 0 0 1 12 21a8.966 8.966 0 0 1-5.982-2.275M15 9.75a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
                </svg>
                Customer Reasons
              </div>
              <ul class="reasons-list-clean" *ngIf="orderData?.customer_reason?.length > 0; else noCuReas">
                <li *ngFor="let reason of orderData.customer_reason">
                  <div class="reason-content-wrapper">
                    <span class="reason-title" *ngIf="reason?.reason?.title">{{ reason.reason.title }}</span>
                    <span class="reason-text">{{ reason?.reason?.reason_text }}</span>
                    <p class="other-reason" *ngIf="reason?.other_reason">{{ reason.other_reason }}</p>
                  </div>
                </li>
              </ul>
              <ng-template #noCuReas><span class="no-feedback">No reasons recorded</span></ng-template>
            </div>
          </div>
        </div>
        <!-- ASSIGNED DRIVER -->
        <div class="driver-section">
          <h3 class="section-title">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
              stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round"
                d="M15.75 6a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zM4.501 20.118a7.5 7.5 0 0114.998 0A17.933 17.933 0 0112 21.75c-2.676 0-5.216-.584-7.499-1.632z" />
            </svg>
            Assigned To
          </h3>
          <div class="driver-assignment" [class.unassigned]="!driverAssigned">
            <div class="driver-info" *ngIf="driverAssigned">
              <div class="driver-avatar">
                <img *ngIf="orderData?.current_driver?.profile_image" [src]="orderData.current_driver.profile_image"
                  [alt]="orderData?.current_driver?.first_name">
                <ng-container *ngIf="!orderData?.current_driver?.profile_image">
                  {{ getDriverInitials(orderData?.current_driver) }}
                </ng-container>
              </div>
              <div class="driver-details">
                <div class="driver-name">{{ orderData?.current_driver.first_name }}
                  {{ orderData?.current_driver?.last_name }}</div>
                <div class="driver-date"><span class="date-prefix">On</span> {{ convertToLocalDate(orderData?.dely_date)
                  }}</div>
              </div>
            </div>
            <div class="driver-info" *ngIf="!driverAssigned">
              <div class="driver-avatar">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
                  stroke="currentColor" style="width: 20px; height: 20px; opacity: 0.6;">
                  <path stroke-linecap="round" stroke-linejoin="round"
                    d="M15.75 6a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zM4.501 20.118a7.5 7.5 0 0114.998 0A17.933 17.933 0 0112 21.75c-2.676 0-5.216-.584-7.499-1.632z" />
                </svg>
              </div>
              <div class="driver-details">
                <div class="driver-name">No Driver Assigned</div>
                <div class="driver-date">Awaiting assignment</div>
              </div>
            </div>
            <div
              *ngIf="driverAssigned && orderData?.order_status.toLowerCase() != 'successful' && orderData?.order_status.toLowerCase() != 'unsuccessful' && orderData?.order_status.toLowerCase() != 'cancelled'"
              class="driver-actions">
              <button class="driver-action-btn btn-reassign" (click)="openReAssignOrder()">
                <svg width="16" height="16" fill="currentColor" viewBox="0 0 20 20">
                  <path
                    d="M8 9a3 3 0 100-6 3 3 0 000 6zM8 11a6 6 0 016 6H2a6 6 0 016-6zM16 7a1 1 0 10-2 0v1h-1a1 1 0 100 2h1v1a1 1 0 102 0v-1h1a1 1 0 100-2h-1V7z" />
                </svg>
                Reassign
              </button>
              <button class="driver-action-btn btn-unassign" (click)="unassignDriver()">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
                  stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round"
                    d="M22 10.5h-6m-2.25-4.125a3.375 3.375 0 11-6.75 0 3.375 3.375 0 016.75 0zM4 19.235v-.11a6.375 6.375 0 0112.75 0v.109A12.318 12.318 0 0110.374 21c-2.331 0-4.512-.645-6.374-1.766z" />
                </svg>
                Unassign
              </button>
            </div>
            <div *ngIf="driverAssigned 
        && (orderData?.order_status?.toLowerCase() == 'unsuccessful' 
        || orderData?.order_status?.toLowerCase() == 'cancelled')" class="driver-actions">

              <button class="driver-action-btn btn-reassign" (click)="rescheduleOrder()"
                [disabled]="orderData?.extra_data?.rescheduled" [ngClass]="{
            'disabled-item': orderData?.extra_data?.rescheduled,
            'cursor-pointer': !orderData?.extra_data?.rescheduled
          }" [matTooltip]="
            orderData?.extra_data?.rescheduled 
              ? 'This order is already rescheduled'
              : ''
          ">

                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
                  stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round"
                    d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0l3.181 3.183a8.25 8.25 0 0013.803-3.7M4.031 9.865a8.25 8.25 0 0113.803-3.7l3.181 3.182m0-4.991v4.99" />
                </svg>
                Reschedule
              </button>
            </div>

          </div>
        </div>

        <!-- PHONE NUMBERS -->
        <div class="phone-section">
          <h3 class="phone-section-header">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
              stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round"
                d="M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 002.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.38a12.035 12.035 0 01-7.143-7.143c-.162-.441.004-.928.38-1.21l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 00-1.091-.852H4.5A2.25 2.25 0 002.25 4.5v2.25z" />
            </svg>
            Contact Information
          </h3>
          <div class="phone-grid">
            <!-- Driver Phone -->
            <div class="phone-card" [class.empty]="!hasDriverPhone()">
              <div class="phone-header">
                <div class="phone-icon-badge">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
                    stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round"
                      d="M15 9h3.75M15 12h3.75M15 15h3.75M4.5 19.5h15a2.25 2.25 0 0 0 2.25-2.25V6.75A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25v10.5A2.25 2.25 0 0 0 4.5 19.5Zm6-10.125a1.875 1.875 0 1 1-3.75 0 1.875 1.875 0 0 1 3.75 0Zm1.294 6.336a6.721 6.721 0 0 1-3.17.789 6.721 6.721 0 0 1-3.168-.789 3.376 3.376 0 0 1 6.338 0Z" />
                  </svg>
                </div>
                <div class="phone-header-text">
                  <div class="phone-title">Driver</div>
                  <div class="phone-name" [title]="getDriverFullName()">
                    {{ getDriverFullName() }}
                  </div>
                </div>
              </div>

              <div class="phone-field-label">Contact Number</div>

              <div class="phone-number-display">
                <div class="phone-inline-list">
                  <div class="phone-inline-item" *ngIf="hasDriverPhone(); else driverPhonePlaceholder">
                    <span class="phone-number-text">
                      <span *ngIf="orderData?.current_driver?.country_code" class="country-prefix">{{
                        orderData.current_driver.country_code }}</span>
                      {{ orderData.current_driver.phone_number }}
                    </span>
                    <button class="phone-copy-btn-mini"
                      (click)="copyToClipboard((orderData?.current_driver?.country_code || '') + (orderData?.current_driver?.phone_number || ''))"
                      title="Copy driver number">
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2.5"
                        stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round"
                          d="M15.666 3.888A2.25 2.25 0 0013.5 2.25h-3c-1.03 0-1.9.693-2.166 1.638m7.332 0c.055.194.084.4.084.612v0a.75.75 0 01-.75.75H9a.75.75 0 01-.75-.75v0c0-.212.03-.418.084-.612m7.332 0c.646.049 1.288.11 1.927.184 1.1.128 1.907 1.077 1.907 2.185V19.5a2.25 2.25 0 01-2.25 2.25H6.75A2.25 2.25 0 014.5 19.5V6.257c0-1.108.806-2.057 1.907-2.185a48.208 48.208 0 011.927-.184" />
                      </svg>
                    </button>
                  </div>
                  <ng-template #driverPhonePlaceholder>
                    <span class="phone-number-text empty">
                      {{ getDriverPhonePlaceholder() }}
                    </span>
                  </ng-template>
                </div>
              </div>
            </div>

            <!-- Customer Phone -->
            <div class="phone-card" [class.empty]="!orderData?.customer_phone && !getCustomerAltPhone()">
              <div class="phone-header">
                <div class="phone-icon-badge">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
                    stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round"
                      d="M17.982 18.725A7.488 7.488 0 0 0 12 15.75a7.488 7.488 0 0 0-5.982 2.975m11.963 0a9 9 0 1 0-11.963 0m11.963 0A8.966 8.966 0 0 1 12 21a8.966 8.966 0 0 1-5.982-2.275M15 9.75a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
                  </svg>
                </div>
                <div class="phone-header-text">
                  <div class="phone-title">Customer</div>
                  <div class="phone-name" [title]="orderData?.customer_name || 'N/A'">
                    {{ orderData?.customer_name || 'N/A' }}
                  </div>
                </div>
              </div>

              <div class="phone-field-label">Contact Number</div>

              <div class="phone-number-display">
                <div class="phone-inline-list">
                  <!-- Primary Phone -->
                  <div class="phone-inline-item" *ngIf="orderData?.customer_phone">
                    <span class="phone-number-text">
                      <span *ngIf="orderData?.country_code" class="country-prefix">{{ orderData.country_code }}</span>
                      {{ orderData.customer_phone }}
                    </span>
                    <button class="phone-copy-btn-mini"
                      (click)="copyToClipboard((orderData?.country_code || '') + (orderData?.customer_phone || ''))"
                      title="Copy primary number">
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2.5"
                        stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round"
                          d="M15.666 3.888A2.25 2.25 0 0013.5 2.25h-3c-1.03 0-1.9.693-2.166 1.638m7.332 0c.055.194.084.4.084.612v0a.75.75 0 01-.75.75H9a.75.75 0 01-.75-.75v0c0-.212.03-.418.084-.612m7.332 0c.646.049 1.288.11 1.927.184 1.1.128 1.907 1.077 1.907 2.185V19.5a2.25 2.25 0 01-2.25 2.25H6.75A2.25 2.25 0 014.5 19.5V6.257c0-1.108.806-2.057 1.907-2.185a48.208 48.208 0 011.927-.184" />
                      </svg>
                    </button>
                  </div>

                  <!-- Separator if both primary and secondary exist -->
                  <span class="phone-inline-divider" *ngIf="orderData?.customer_phone && getCustomerAltPhone()">|</span>

                  <!-- Secondary / Alternate Phone -->
                  <div class="phone-inline-item" *ngIf="getCustomerAltPhone()">
                    <span class="phone-badge-alt">ALT</span>
                    <span class="phone-number-text">
                      <span *ngIf="orderData?.country_code && !getCustomerAltPhone()?.startsWith('+')" class="country-prefix">{{ orderData.country_code }}</span>
                      {{ getCustomerAltPhone() }}
                    </span>
                    <button class="phone-copy-btn-mini"
                      (click)="copyToClipboard(getCustomerAltPhoneFull())"
                      title="Copy alternate number">
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2.5"
                        stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round"
                          d="M15.666 3.888A2.25 2.25 0 0013.5 2.25h-3c-1.03 0-1.9.693-2.166 1.638m7.332 0c.055.194.084.4.084.612v0a.75.75 0 01-.75.75H9a.75.75 0 01-.75-.75v0c0-.212.03-.418.084-.612m7.332 0c.646.049 1.288.11 1.927.184 1.1.128 1.907 1.077 1.907 2.185V19.5a2.25 2.25 0 01-2.25 2.25H6.75A2.25 2.25 0 014.5 19.5V6.257c0-1.108.806-2.057 1.907-2.185a48.208 48.208 0 011.927-.184" />
                      </svg>
                    </button>
                  </div>

                  <!-- Empty state if neither phone exists -->
                  <span class="phone-number-text empty" *ngIf="!orderData?.customer_phone && !getCustomerAltPhone()">
                    Not available
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- SEND NOTIFICATION -->
        <div class="notification-section">
          <div class="notification-content">
            <div class="notification-left">
              <h3 class="notification-header">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                  stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round"
                    d="M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0L3.32 8.91a2.25 2.25 0 01-1.07-1.916V6.75" />
                </svg>
                Send Notification To
              </h3>
              <p class="notification-description">Choose recipient and send instant updates</p>
              <div class="mode-selector">
                <button class="mode-option" [class.active]="notificationRecipient === 'driver'"
                  (click)="toggleNotificationMode('driver')">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
                    stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round"
                      d="M15 9h3.75M15 12h3.75M15 15h3.75M4.5 19.5h15a2.25 2.25 0 0 0 2.25-2.25V6.75A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25v10.5A2.25 2.25 0 0 0 4.5 19.5Zm6-10.125a1.875 1.875 0 1 1-3.75 0 1.875 1.875 0 0 1 3.75 0Zm1.294 6.336a6.721 6.721 0 0 1-3.17.789 6.721 6.721 0 0 1-3.168-.789 3.376 3.376 0 0 1 6.338 0Z" />
                  </svg>
                  <span>Driver</span>
                </button>
                <button class="mode-option" [class.active]="notificationRecipient === 'customer'"
                  (click)="toggleNotificationMode('customer')">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
                    stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round"
                      d="M17.982 18.725A7.488 7.488 0 0 0 12 15.75a7.488 7.488 0 0 0-5.982 2.975m11.963 0a9 9 0 1 0-11.963 0m11.963 0A8.966 8.966 0 0 1 12 21a8.966 8.966 0 0 1-5.982-2.275M15 9.75a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
                  </svg>
                  <span>Customer</span>
                </button>
              </div>
            </div>
            <button class="notification-button" (click)="openModal()">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
                stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round"
                  d="M6 12L3.269 3.126A59.768 59.768 0 0121.485 12 59.77 59.77 0 013.27 20.876L5.999 12zm0 0h7.5" />
              </svg>
              Send Notification
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Notification Panel Modal -->
<div class="modal-overlay" [class.active]="isNotificationPanelOpen" (click)="closeNotifications()">
  <div class="notification-panel" [class.active]="isNotificationPanelOpen" (click)="$event.stopPropagation()">
    <!-- Header -->
    <div class="panel-header">
      <div class="header-top">
        <h2 class="panel-title">Recent Notifications</h2>
        <button class="close-btn" (click)="closeNotifications()">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
            stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>
      <div class="tabs-container">
        <button class="tab" [class.active]="activeTab === 'customer'" (click)="setActiveTab('customer')">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
            stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round"
              d="M17.982 18.725A7.488 7.488 0 0 0 12 15.75a7.488 7.488 0 0 0-5.982 2.975m11.963 0a9 9 0 1 0-11.963 0m11.963 0A8.966 8.966 0 0 1 12 21a8.966 8.966 0 0 1-5.982-2.275M15 9.75a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
          </svg>
          Customer
        </button>
        <button class="tab" [class.active]="activeTab === 'driver'" (click)="setActiveTab('driver')">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
            stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round"
              d="M15 9h3.75M15 12h3.75M15 15h3.75M4.5 19.5h15a2.25 2.25 0 0 0 2.25-2.25V6.75A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25v10.5A2.25 2.25 0 0 0 4.5 19.5Zm6-10.125a1.875 1.875 0 1 1-3.75 0 1.875 1.875 0 0 1 3.75 0Zm1.294 6.336a6.721 6.721 0 0 1-3.17.789 6.721 6.721 0 0 1-3.168-.789 3.376 3.376 0 0 1 6.338 0Z" />
          </svg>
          Driver
        </button>
      </div>
    </div>

    <!-- Content -->
    <div class="panel-content">
      <!-- View All Button -->
      <div class="view-all-section">
        <button class="view-all-btn-top" (click)="viewAllNotifications()" [disabled]="
    (activeTab === 'customer' && (!orderDetailRn || orderDetailRn.length === 0)) ||
    (activeTab === 'driver' && (!orderDetailRnD || orderDetailRnD.length === 0))
  ">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
            stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round"
              d="M13.5 6H5.25A2.25 2.25 0 003 8.25v10.5A2.25 2.25 0 005.25 21h10.5A2.25 2.25 0 0018 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25" />
          </svg>
          View All {{ activeTab === 'customer' ? 'Customer' : 'Driver' }} Notifications
        </button>
      </div>

      <div *ngIf="activeTab == 'customer'" class="notification-list">
        <div class="notification-item" *ngFor="let notification of orderDetailRn"
          [class.has-image]="notification.images.length > 0">
          <div class="notification-item-top" *ngIf="notification.images.length > 0; else normalLayout">
            <div class="notification-icon">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                <path
                  d="M5.85 3.5a.75.75 0 00-1.117-1 9.719 9.719 0 00-2.348 4.876.75.75 0 001.479.248A8.219 8.219 0 015.85 3.5zM19.267 2.5a.75.75 0 10-1.118 1 8.22 8.22 0 011.987 4.124.75.75 0 001.48-.248A9.72 9.72 0 0019.266 2.5z" />
                <path fill-rule="evenodd"
                  d="M12 2.25A6.75 6.75 0 005.25 9v.75a8.217 8.217 0 01-2.119 5.52.75.75 0 00.298 1.206c1.544.57 3.16.99 4.831 1.243a3.75 3.75 0 107.48 0 24.583 24.583 0 004.83-1.244.75.75 0 00.298-1.205 8.217 8.217 0 01-2.118-5.52V9A6.75 6.75 0 0012 2.25zM9.75 18c0-.034 0-.067.002-.1a25.05 25.05 0 004.496 0l.002.1a2.25 2.25 0 11-4.5 0z"
                  clip-rule="evenodd" />
              </svg>
            </div>
            <div class="notification-content">
              <div class="notification-message">{{ notification.notification }}</div>
              <div class="notification-time">{{ notification.when_sent }}</div>
            </div>
            <div class="unread-badge" *ngIf="notification.isUnread"></div>
            <img [src]="notification.images[0].image_url" alt="Notification image" class="notification-image">
          </div>

          <ng-template #normalLayout>
            <div class="notification-icon">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                <path
                  d="M5.85 3.5a.75.75 0 00-1.117-1 9.719 9.719 0 00-2.348 4.876.75.75 0 001.479.248A8.219 8.219 0 015.85 3.5zM19.267 2.5a.75.75 0 10-1.118 1 8.22 8.22 0 011.987 4.124.75.75 0 001.48-.248A9.72 9.72 0 0019.266 2.5z" />
                <path fill-rule="evenodd"
                  d="M12 2.25A6.75 6.75 0 005.25 9v.75a8.217 8.217 0 01-2.119 5.52.75.75 0 00.298 1.206c1.544.57 3.16.99 4.831 1.243a3.75 3.75 0 107.48 0 24.583 24.583 0 004.83-1.244.75.75 0 00.298-1.205 8.217 8.217 0 01-2.118-5.52V9A6.75 6.75 0 0012 2.25zM9.75 18c0-.034 0-.067.002-.1a25.05 25.05 0 004.496 0l.002.1a2.25 2.25 0 11-4.5 0z"
                  clip-rule="evenodd" />
              </svg>
            </div>
            <div class="notification-content">
              <div class="notification-message">{{ notification.notification }}</div>
              <div class="notification-time">{{ notification.when_sent }}</div>
            </div>
            <div class="unread-badge" *ngIf="notification.isUnread"></div>
          </ng-template>
        </div>
        <div *ngIf="!orderDetailRn || orderDetailRn.length === 0 && activeTab == 'customer'" class="mt-4 PacelId">
          No Recent Notification
        </div>
      </div>
      <div *ngIf="activeTab == 'driver'" class="notification-list">
        <div class="notification-item" *ngFor="let notification of orderDetailRnD"
          [class.has-image]="notification.image.length > 0">
          <div class="notification-item-top" *ngIf="notification.image.length > 0; else normalLayout">
            <div class="notification-icon">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                <path
                  d="M5.85 3.5a.75.75 0 00-1.117-1 9.719 9.719 0 00-2.348 4.876.75.75 0 001.479.248A8.219 8.219 0 015.85 3.5zM19.267 2.5a.75.75 0 10-1.118 1 8.22 8.22 0 011.987 4.124.75.75 0 001.48-.248A9.72 9.72 0 0019.266 2.5z" />
                <path fill-rule="evenodd"
                  d="M12 2.25A6.75 6.75 0 005.25 9v.75a8.217 8.217 0 01-2.119 5.52.75.75 0 00.298 1.206c1.544.57 3.16.99 4.831 1.243a3.75 3.75 0 107.48 0 24.583 24.583 0 004.83-1.244.75.75 0 00.298-1.205 8.217 8.217 0 01-2.118-5.52V9A6.75 6.75 0 0012 2.25zM9.75 18c0-.034 0-.067.002-.1a25.05 25.05 0 004.496 0l.002.1a2.25 2.25 0 11-4.5 0z"
                  clip-rule="evenodd" />
              </svg>
            </div>
            <div class="notification-content">
              <div class="notification-message">{{ notification.notification }}</div>
              <div class="notification-time">{{ notification.when_sent }}</div>
            </div>
            <div class="unread-badge" *ngIf="notification.isUnread"></div>
            <img [src]="notification.image[0].image_url" alt="Notification image" class="notification-image">
          </div>

          <ng-template #normalLayout>
            <div class="notification-icon">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                <path
                  d="M5.85 3.5a.75.75 0 00-1.117-1 9.719 9.719 0 00-2.348 4.876.75.75 0 001.479.248A8.219 8.219 0 015.85 3.5zM19.267 2.5a.75.75 0 10-1.118 1 8.22 8.22 0 011.987 4.124.75.75 0 001.48-.248A9.72 9.72 0 0019.266 2.5z" />
                <path fill-rule="evenodd"
                  d="M12 2.25A6.75 6.75 0 005.25 9v.75a8.217 8.217 0 01-2.119 5.52.75.75 0 00.298 1.206c1.544.57 3.16.99 4.831 1.243a3.75 3.75 0 107.48 0 24.583 24.583 0 004.83-1.244.75.75 0 00.298-1.205 8.217 8.217 0 01-2.118-5.52V9A6.75 6.75 0 0012 2.25zM9.75 18c0-.034 0-.067.002-.1a25.05 25.05 0 004.496 0l.002.1a2.25 2.25 0 11-4.5 0z"
                  clip-rule="evenodd" />
              </svg>
            </div>
            <div class="notification-content">
              <div class="notification-message">{{ notification.notification }}</div>
              <div class="notification-time">{{ notification.when_sent }}</div>
            </div>
            <div class="unread-badge" *ngIf="notification.isUnread"></div>
          </ng-template>
        </div>
      </div>
      <div *ngIf="!orderDetailRnD || orderDetailRnD.length === 0 && activeTab == 'driver'" class="mt-4 PacelId">
        No Recent Notification
      </div>
    </div>
  </div>
</div>
<!-- SEND NOTIFICATION MODAL -->
<div *ngIf="isModalOpen" class="modal show" (click)="onBackdropClick($event)">
  <div class="modal-content">
    <div class="modal-header">
      <h2 class="modal-title">
        <svg class="modal-icon" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
          stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round"
            d="M6 12L3.269 3.126A59.768 59.768 0 0121.485 12 59.77 59.77 0 013.27 20.876L5.999 12zm0 0h7.5" />
        </svg>
        Send Notification
      </h2>
      <button class="modal-close" (click)="closeModal()">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
    </div>

    <div class="modal-body">
      <div class="form-group">
        <label class="form-label">
          <svg class="label-icon" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
            stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round"
              d="M15 19.128a9.38 9.38 0 002.625.372 9.337 9.337 0 004.121-.952 4.125 4.125 0 00-7.533-2.493M15 19.128v-.003c0-1.113-.285-2.16-.786-3.07M15 19.128v.106A12.318 12.318 0 018.624 21c-2.331 0-4.512-.645-6.374-1.766l-.001-.109a6.375 6.375 0 0111.964-3.07M12 6.375a3.375 3.375 0 11-6.75 0 3.375 3.375 0 016.75 0zm8.25 2.25a2.625 2.625 0 11-5.25 0 2.625 2.625 0 015.25 0z" />
          </svg>
          Send To
          <span class="required">*</span>
        </label>
        <div class="recipient-type-toggle">
          <button class="toggle-option" [class.active]="recipientType === 'customer'"
            (click)="toggleRecipientType('customer')">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
              stroke="currentColor" class="toggle-icon">
              <path stroke-linecap="round" stroke-linejoin="round"
                d="M17.982 18.725A7.488 7.488 0 0 0 12 15.75a7.488 7.488 0 0 0-5.982 2.975m11.963 0a9 9 0 1 0-11.963 0m11.963 0A8.966 8.966 0 0 1 12 21a8.966 8.966 0 0 1-5.982-2.275M15 9.75a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
            </svg>
            Customers
          </button>
          <button class="toggle-option" [class.active]="recipientType === 'driver'"
            (click)="toggleRecipientType('driver')">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
              stroke="currentColor" class="toggle-icon">
              <path stroke-linecap="round" stroke-linejoin="round"
                d="M15 9h3.75M15 12h3.75M15 15h3.75M4.5 19.5h15a2.25 2.25 0 0 0 2.25-2.25V6.75A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25v10.5A2.25 2.25 0 0 0 4.5 19.5Zm6-10.125a1.875 1.875 0 1 1-3.75 0 1.875 1.875 0 0 1 3.75 0Zm1.294 6.336a6.721 6.721 0 0 1-3.17.789 6.721 6.721 0 0 1-3.168-.789 3.376 3.376 0 0 1 6.338 0Z" />
            </svg>
            Drivers
          </button>
        </div>
      </div>

      <div class="form-group">
        <label class="form-label">
          <svg class="label-icon" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
            stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round"
              d="M7.5 8.25h9m-9 3H12m-9.75 1.51c0 1.6 1.123 2.994 2.707 3.227 1.129.166 2.27.293 3.423.379.35.026.67.21.865.501L12 21l2.755-4.133a1.14 1.14 0 01.865-.501 48.172 48.172 0 003.423-.379c1.584-.233 2.707-1.626 2.707-3.228V6.741c0-1.602-1.123-2.995-2.707-3.228A48.394 48.394 0 0012 3c-2.392 0-4.744.175-7.043.513C3.373 3.746 2.25 5.14 2.25 6.741v6.018z" />
          </svg>
          Message
          <span class="required">*</span>
        </label>
        <textarea class="modal-textarea" placeholder="Enter your message here..." [maxlength]="maxChars"
          [(ngModel)]="messageText" (input)="updateCharCount()">
        </textarea>
        <div class="error-text" *ngIf="showError">
          Message is required
        </div>
        <div class="char-count" [ngClass]="getCharCountClass()">
          <span>{{ charCount }}</span> / {{ maxChars }}
        </div>
      </div>

      <div class="form-group">
        <label class="form-label">
          <svg class="label-icon" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
            stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round"
              d="M2.25 15.75l5.159-5.159a2.25 2.25 0 013.182 0l5.159 5.159m-1.5-1.5l1.409-1.409a2.25 2.25 0 013.182 0l2.909 2.909m-18 3.75h16.5a1.5 1.5 0 001.5-1.5V6a1.5 1.5 0 00-1.5-1.5H3.75A1.5 1.5 0 002.25 6v12a1.5 1.5 0 001.5 1.5zm10.5-11.25h.008v.008h-.008V8.25zm.375 0a.375.375 0 11-.75 0 .375.375 0 01.75 0z" />
          </svg>
          Attachments
          <span class="optional">(Optional)</span>
        </label>
        <input type="file" #fileInput class="file-input" multiple accept="image/*" (change)="onFileSelect($event)">
        <label for="fileInput" class="file-upload-btn"
          (click)="fileInput.click();$event.preventDefault(); $event.stopPropagation()">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
            stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
          </svg>
          Add Files
        </label>
        <div class="file-preview-list">
          <div *ngFor="let preview of filePreviews; let i = index" class="file-preview-item">
            <img [src]="preview.url" [alt]="preview.file.name">
            <button class="file-preview-remove" (click)="removeFile(i)" type="button">×</button>
          </div>
        </div>
      </div>
    </div>



    <div class="modal-footer">
      <button class="btn-secondary" (click)="closeModal()">Cancel</button>
      <button class="btn-primary" (click)="sendNotification()">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round"
            d="M6 12L3.269 3.126A59.768 59.768 0 0121.485 12 59.77 59.77 0 013.27 20.876L5.999 12zm0 0h7.5" />
        </svg>
        Send Notification
      </button>
    </div>
  </div>
</div>

<app-assign-order-modal *ngIf="assignorder" [orderIds]="selectedOrders" [visible]="showAssignOrderModal"
  [isassign]="showAssign" (close)="showAssignOrderModal = false" (assign)="handleAssignOrder($event)">
</app-assign-order-modal>
<!-- Signature Full View Modal -->
<div class="signature-modal-overlay" [class.active]="isSignatureModalOpen" (click)="closeSignatureModal()">
  <div class="signature-modal-content" (click)="$event.stopPropagation()">
    <button class="signature-modal-close" (click)="closeSignatureModal()">
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2.5" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
      </svg>
    </button>
    <div class="signature-modal-body">
      <img [src]="signatureModalImage" alt="Signature" class="full-signature-image">
    </div>
  </div>
</div>

<!-- Order Edit History Modal -->
<div class="history-modal-overlay" [class.active]="isHistoryModalOpen" (click)="closeHistoryModal()">
  <div class="history-modal-content" (click)="$event.stopPropagation()">
    <div class="history-modal-header">
      <h3 class="history-modal-title">Order Edit History</h3>
      <button class="history-modal-close" (click)="closeHistoryModal()">✕</button>
    </div>
    <div class="history-modal-body">
      <div *ngIf="hasEditLogs(); else noLogs" class="history-table-container">
        <table class="history-table">
          <thead>
            <tr>
              <th>Edited By</th>
              <th>Date & Time</th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngFor="let log of orderData.order_logs">
              <tr *ngIf="!log.added_by">
                <td class="user-cell">
                  <div class="user-info">
                    <img *ngIf="getLogUserImage(log)" [src]="getLogUserImage(log)" alt="User Image"
                      class="user-avatar" />
                    <div *ngIf="!getLogUserImage(log)" class="user-initials">{{ getLogUserInitials(log) }}</div>
                    <span>{{ getLogUser(log) }}</span>
                  </div>
                </td>
                <td class="date-cell">{{ getLogDateTime(log) }}</td>
              </tr>
            </ng-container>
          </tbody>
        </table>
      </div>
      <ng-template #noLogs>
        <div class="no-history-state">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
            stroke="currentColor" class="no-history-icon"
            style="width: 48px; height: 48px; margin-bottom: 12px; stroke-width: 1.5; color: #9ca3af;">
            <path stroke-linecap="round" stroke-linejoin="round" d="M12 6v6h4.5m4.5 0a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          <p>No edit history found for this order.</p>
        </div>
      </ng-template>
    </div>
  </div>
</div>